

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLACTIVEPLANS= createAsyncThunk(
  "getAllActivePlans/getAllActivePlans",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllActivePlansSlice = createSlice({
  name: "getAllActivePlansSlice",
  initialState: {
    getAllActivePlans: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllActivePlans: (state) => {
        state.getAllActivePlans.loading = false
        state.getAllActivePlans.error = false
        state.getAllActivePlans.data = []
        state.getAllActivePlans.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLACTIVEPLANS.fulfilled, (state, action) => {
      state.getAllActivePlans = {
        ...state.getAllActivePlans,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLACTIVEPLANS.pending, (state, action) => {
      state.getAllActivePlans = {
        ...state.getAllActivePlans,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLACTIVEPLANS.rejected, (state, action) => {
      state.getAllActivePlans = {
        ...state.getAllActivePlans,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllActivePlansAction = {
    GETALLACTIVEPLANS,
};

export { getAllActivePlansAction };
export default getAllActivePlansSlice.reducer;
export const {setInitialStateOfgetAllActivePlans} = getAllActivePlansSlice.actions
